import React, { useContext, useState } from 'react';
import Button from '../../../../Components/Button';
import { Card, CardBody } from '../../../../Components/Card';
import { UserContext } from '../../../../Context/UserContext';
import SelectField from '../../../../Components/SelectField';
import { ThemeContext } from '../../../../Context/ThemeContext';
import Toast from '../../../../Components/Toast';
const Appearance = () => {
    const { user } = useContext(UserContext);
    const { theme, setTheme } = useContext(ThemeContext);
    const [currentTheme, setCurrentTheme] = useState(theme);
    const [toastData, setToastData] = useState({ type: "", message: "", isOpen: false });

    const handleSubmit = async (event) => {
        event.preventDefault();
        setToastData({
            type: "success",
            message: "Your theme has been updated successfully. Please wait a moment while we apply the new theme.",
            isOpen: true,
            position: 'top-right'
        });
        setTimeout(() => {
            window.location.reload();
            setTheme(currentTheme);
        }, 2000);        
    }; 
    const changeTheme = (theme) => {
        setCurrentTheme(theme.value)
    } 
    const resetToastData = () => {
        setToastData({ type: "", message: "", isOpen: false });
    }                  
    return (
        <Card className="mb-5">
            <Toast toast={toastData} resetToast={resetToastData} hasHeader={false} />
            <CardBody>
                <form onSubmit={handleSubmit} noValidate>
                    <p className="h5 text-center mb-4">Appearance</p>
                    <div className="mb-4">
                        <SelectField
                            className="domain-dropdown"
                            data={[{text: "Light", value : "light"}, {text: "Dark", value : "dark"}, {text: "High Contrast", value : "high-contrast"}, {text : "Follow operating system theme", value : "OS-theme"}]}
                            label="Change Theme"
                            style={{ paddingRight: 12, height:"22px", fontSize:"13px" }}
                            value={currentTheme}
                            onChange={changeTheme}
                        />
                    </div>
                    <div className="d-flex justify-content-center">
                    <Button className="" type="submit">Save</Button>
                    </div>
                </form>
            </CardBody>
        </Card>
    )
};

export default Appearance;
